// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import CommonDismiss from 'app/common/components/Dismiss';
import 'app/viewport/components/TopBar/Dismiss.scss';

import { type KindType } from 'app/common/types';

const bem = bemify('top-bar-dismiss');

type DismissProps = {
  kind?: KindType,
  trackingKey: string,
  profileId: number,
  onDismiss: (trackingKey: string, profileId: number) => void,
  iconSize: number,
};

const Dismiss = (props: DismissProps) => {
  const onDismiss = () => {
    props.onDismiss(props.trackingKey, props.profileId);
  };
  return (
    <CommonDismiss
      aria-label="Close Top Bar"
      className={bem(toModifiers(props.kind))}
      iconSize={props.iconSize}
      onDismiss={onDismiss}
    />
  );
};

Dismiss.defaultProps = {
  iconSize: 10,
};

export default Dismiss;
